var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-management_inviting-modal" },
    [
      _c(
        "HKLModal",
        {
          ref: "modal",
          attrs: {
            title: _vm.$t("hint.inviteAllUsers"),
            okBtnAction: "yesInvite",
          },
          on: { onOkClick: _vm.saveAndSendInviteEmails },
        },
        [
          _c("div", { staticClass: "invite-user__slot" }, [
            _vm.shouldShowSubAccounts
              ? _c("div", { staticClass: "invite-users__body" }, [
                  _c("div", { staticClass: "invite-users__title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("tenancy.tenancyUserWithS")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "invite-users__list" },
                    _vm._l(_vm.needInvitedSubAccounts, function (item) {
                      return _c("li", { key: item.id }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.username) +
                            "\n          "
                        ),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm.shouldShowContractors
              ? _c("div", { staticClass: "invite-users__body" }, [
                  _c("div", { staticClass: "invite-users__title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("tenancy.sawpContractorWithS")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "invite-users__list" },
                    _vm._l(
                      _vm.needInvitedStandaloneContractors,
                      function (item) {
                        return _c("li", { key: item.id }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.userAccount) +
                              "\n          "
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }